// 현재 브라우저에서 localStrogae 사용 가능여부 확인
function storageAvailable(type: string) {
    var storage;
    try {
        storage = (window as any)[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch(e) {
        return e instanceof DOMException && (
            // Firefox를 제외한 모든 브라우저
            e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // 코드가 존재하지 않을 수도 있기 떄문에 이름 필드도 확인합니다.
            // Firefox를 제외한 모든 브라우저
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // 이미 저장된 것이있는 경우에만 QuotaExceededError를 확인하십시오.
            (storage && storage.length !== 0);
    }
}

export default (function () {
    return {
        /**
         * 로컬스토리지에 데이터를 저장합니다.
         * @param value 저장할 데이터
         */
        set(value: any, key?: string) {
            if (!storageAvailable('localStorage')) {
                return;
            }

            if(key){
                localStorage.setItem(key, JSON.stringify(value));
            }
            else{
                localStorage.setItem('org-list', JSON.stringify(value));
            }
        },

        /**
         * 로컬스토리지에서 데이터를 가져옵니다.
         */
        get(key?:string) {
            if (!storageAvailable('localStorage')) {
                return
            }

            if(key){
                const value = localStorage.getItem(key);
                return value ? JSON.parse(value) : null;
            }else{
                const value = localStorage.getItem('org-list');
                return value ? JSON.parse(value) : null;
            }
        },

        /**
         * 로컬스토리지에서 데이터를 제거합니다.
         */
        remove(key?: string | undefined){
            if(this.get(key)){
                localStorage.removeItem(key || 'org-list');
            }
        }
    }
})()
